var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFitting = function SvgFitting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.825 8 16 11.956 12.175 8 11 9.218l3.333 3.454v6.656L11 22.782 12.175 24 16 20.044 19.825 24 21 22.782l-3.333-3.455v-6.654L21 9.218z",
    clipRule: "evenodd"
  })));
};
export { SvgFitting as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.825 8L16 11.9557L12.175 8L11 9.21781L14.3333 12.6725L14.3333 19.3275L11 22.7822L12.175 24L16 20.0443L19.825 24L21 22.7822L17.6666 19.3273L17.6666 12.6727L21 9.21781L19.825 8Z' fill='%234A6067'/%3e %3c/svg%3e";